// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyFilesDropzone_container__3s2kM"};